/**
 * List container for project rows
 * Story 226: Projects Dashboard
 */

import type { ProjectListItem } from '../../hooks/useProjects';
import { ProjectRow } from './ProjectRow';
import './ProjectsList.css';

interface ProjectsListProps {
  projects: ProjectListItem[];
  onSelectProject: (projectSlug: string) => void;
  onExport?: (slug: string) => void;
}

export function ProjectsList({ projects, onSelectProject, onExport }: ProjectsListProps) {
  return (
    <div className="projects-list">
      <div className="projects-list__header">
        <span className="projects-list__header-name">Project</span>
        <span className="projects-list__header-stories">Stories</span>
        <span className="projects-list__header-in-progress">In Progress</span>
        <span className="projects-list__header-done">Done</span>
        <span className="projects-list__header-users">Users</span>
        <span className="projects-list__header-updated">Updated</span>
      </div>
      <div className="projects-list__body">
        {projects.map((project) => (
          <ProjectRow
            key={project.id}
            project={project}
            onClick={() => onSelectProject(project.slug)}
            onExport={onExport}
          />
        ))}
      </div>
    </div>
  );
}
